export const PRICE__PREMIUM_45_DAYS = 25;
export const PRICE__PREMIUM_1_YEAR = 140;
export const PRICE__PREMIUM_LIFETIME = 300;

export const pricesByPlanType = {
  premium_45_days  : PRICE__PREMIUM_45_DAYS,
  premium          : PRICE__PREMIUM_1_YEAR,
  premium_lifetime : PRICE__PREMIUM_LIFETIME,
};
